<template>
  <div class="wxworkchatinspection">
    <el-divider content-position="left">企业微信聊天记录质检</el-divider>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="" name="1">
        <template slot="title">
          <span style="color: #409eff">筛选</span>
        </template>
        <div style="display: flex">
          <div style="display: inline-block">
            <el-date-picker
              v-model="searchForm.chooseDate"
              type="datetimerange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="typeInPickerOptions"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
              size="mini"
            >
            </el-date-picker>
            <i
              class="el-icon-s-opportunity"
              style="color: #e6a23c; margin-top: 0.08rem; font-size: 0.18rem"
              >时间段超过一个月的无法选择</i
            >
          </div>
          <div style="margin-left: 0.3rem">
            <el-select
              v-model="searchForm.categoryId"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
              @change="loadCategoryChildren"
            >
              <el-option
                v-for="item in categoryIdOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div style="margin-left: 0.3rem">
            <el-button size="mini" type="warning" @click="clearSome('searchForm')"
              >清空</el-button
            >
            <el-button size="mini" type="primary" @click="getChatHistory">查询</el-button>
          </div>
          <div style="flex: 1; text-align: right;margin-right: .4rem;">
            <a href="wx_in_cate">
              <el-button type="warning" size="mini">分类</el-button>
            </a>
            <a href="wx_in_content">
              <el-button type="primary" size="mini">关键字</el-button>
            </a>
          </div>
        </div>
        <div style="margin-top: 10px" v-if="categoryIdChildrenOptions">
          <el-button size="mini" type="primary" @click="chooseAll">全选</el-button>
          <el-button size="mini" type="warning" @click="chooseAnother">反选</el-button>
        </div>
        <div class="keyword_list">
          <el-checkbox-group v-model="searchForm.checkList">
            <el-checkbox
              :label="item.id"
              v-for="(item, index) in categoryIdChildrenOptions"
              :key="index"
            >
              {{ item.content }}
              <span
                v-if="
                  checkListCount &&
                  Object.keys(checkListCount).indexOf(item.content) !== -1
                "
                style="color: #e6a23c"
                >{{ "(" + checkListCount[item.content] + ")" }}</span
              >
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="middle-table">
    <el-table
      height="calc(100vh - 296px)"
      :data="tableData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="chat_name" label="群名">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.group_chat ? scope.row.group_chat.name : ''"
            :open-delay="500"
            placement="top"
          >
            <span class="hide-style">{{
              scope.row.group_chat ? scope.row.group_chat.name : ""
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发送人">
        <template slot-scope="scope">
          <el-tooltip :content="getSendName(scope.row)" :open-delay="500" placement="top">
            <span class="hide-style">{{ getSendName(scope.row) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="内容">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.content"
            placement="top"
          >
            <span class="hide-style">{{ scope.row.content }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="msgtime" label="发送时间"> </el-table-column>
      <el-table-column fixed="right" label="聊天记录" width="80">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="企业微信聊天记录"
            placement="top"
          >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-s-comment"
              @click="handleWxWorkChatOpen(scope.row)"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="page-footer">
      <el-pagination
      class="pagination-style"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="nowPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </div>
    <el-drawer
      title="企业微信聊天记录"
      direction="rtl"
      :visible.sync="wxWorkChatDrawer"
      :before-close="handWxWorkChatClose"
      size="50%"
    >
      <div class="m-tabs-content">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkChatName"
            :betweenDate="WxworkBetweenDate"
          >
          </wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
export default {
  name: "WxWorkChatInspection",
  components: {
    WxWorkChat,
  },
  data() {
    return {
      checkListCount: "",
      wxWorkChatDrawer: false,
      wxWorkChatId: null,
      wxWorkChatName: null,
      WxworkBetweenDate: "",
      pageSize: 30,
      nowPage: 1,
      total: 0,
      npage: 1,
      tableData: [],
      activeNames: "",
      categoryIdOptions: "",
      categoryIdChildrenOptions: "",
      searchForm: {
        chooseDate: [],
        categoryId: "",
        checkList: [],
      },
      // typeInPickerOptions: {
      //   disabledDate (time) {
      //     return time.getTime() < Date.now() - 3600 * 1000 * 24 * 30
      //   },
      //   shortcuts: [
      //     {
      //       'text': '今天',
      //       onClick (picker) {
      //         const start = new Date()
      //         const end = new Date()
      //         // start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
      //         picker.$emit('pick', [start, end])
      //       }
      //     },
      //     {}
      //   ]
      // }
    };
  },
  methods: {
    loadCategory() {
      this.$axios
        .get("api/wwki/getcate")
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdOptions = data.data;
          }
        })
        .catch();
    },
    loadCategoryChildren(val) {
      this.categoryIdChildrenOptions = "";
      this.searchForm.checkList = [];
      this.$axios
        .get("api/wwi/getcate_children?cateId=" + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdChildrenOptions = data.data;
          }
        })
        .catch();
    },
    clearSome(obj) {
      this.total = 0;
      this.npage = 1;
      this.nowPage = 1;
      this.pageSize = 30;
      this.tableData = [];
      this.checkListCount = "";
      this.activeNames = '';
      let arr = Object.keys(this[obj]);
      arr.map((item) => {
        if (Array.isArray(this[obj][item])) {
          this[obj][item] = [];
        } else {
          this[obj][item] = "";
        }
      });
    },
    getChatHistory() {
      this.checkListCount = "";
      this.activeNames = '';
      if (
        !this.searchForm.chooseDate ||
        this.searchForm.chooseDate.length === 0 ||
        // this.searchForm.categoryId === '' &&
        this.searchForm.checkList.length === 0
      ) {
        this.$message.warning("请选择查询日期和关键字！");
        return false;
      }
      this.searchForm.perPage = this.pageSize;
      this.$axios
        .get("api/wwi/get_chat_history?page=" + this.npage, {
          params: this.searchForm,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.tableData = data.data.data;
            this.checkListCount = data.count;
            this.total = data.data.total;
            this.nowPage = this.npage;
            this.npage = 1;
          } else {
            this.$message.warning(data.msg);
          }
        })
        .catch();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize = val;
      this.getChatHistory();
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.getChatHistory();
    },
    getSendName(row) {
      let name = "未知客户姓名，请添加为企业微信好友";
      if (row.employee) {
        name = row.employee.name;
      }

      if (row.external) {
        name = row.external.name;
      }

      return name;
    },
    handleWxWorkChatOpen(row) {
      this.wxWorkChatDrawer = true;
      setTimeout(() => {
        this.wxWorkChatId = row.roomid;
        this.wxWorkChatName = row.group_chat ? row.group_chat.name : null;
        this.WxworkBetweenDate = row.msgtime;
      });
    },
    handWxWorkChatClose(done) {
      this.wxWorkChatId = null;
      this.wxWorkChatName = null;
      this.WxworkBetweenDate = "";
      done();
    },
    chooseAll() {
      let idArr = this.categoryIdChildrenOptions.map((item) => {
        return item["id"];
      });
      this.searchForm.checkList = [];
      this.searchForm.checkList = idArr;
    },
    chooseAnother() {
      let idArr = this.categoryIdChildrenOptions.map((item) => {
        return item["id"];
      });
      let anotherArr = idArr
        .concat(this.searchForm.checkList)
        .filter(
          (v) => idArr.indexOf(v) === -1 || this.searchForm.checkList.indexOf(v) === -1
        );
      this.searchForm.checkList = [];
      this.searchForm.checkList = anotherArr;
    },
    nowDate(date) {
      return date.split("/");
    },
    getWeek(n, type) {
      // 周
      let now = new Date();
      let day = now.getDay(); // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1);
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7);
        } else {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber);
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1 + 6); // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7 + 6);
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber);
        }
      }
      let date = now.getDate();
      let month = now.getMonth() + 1;

      let s =
        now.getFullYear() +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (date < 10 ? "0" + date : date);
      return s;
    },
    getfirstDateAndlastDate(dateC) {
      let dateStr = dateC;
      let date = new Date(dateStr);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month > 12) {
        month = 1;
        year++;
      }
      if (month < 10) {
        month = "0" + month;
      }
      let monthLastDay = new Date(year, month, 0).getDate();
      let firstDate = year + "-" + month + "-" + "01";
      let lastDate = year + "-" + month + "-" + monthLastDay;
      return [firstDate, lastDate];
    },
    getCurrentDate() {
      let date = new Date();
      let seperator1 = "-";
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    fromLastMonth() {
      let date = new Date();
      let lastMonthDate = "";
      // 获取当前几号，如果小于10则补0
      let day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      let month = date.getMonth();
      let year = date.getFullYear();
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + "-12-" + day;
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = "0" + month;
        }
        lastMonthDate = year + "-" + month + "-" + day;
      }
      return lastMonthDate;
    },
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
    typeInPickerOptions: function () {
      let _this = this;
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24 * 30;
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const todayDate = new Date().toLocaleDateString();
              let dateArr = _this.nowDate(todayDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const dd = new Date();
              dd.setDate(dd.getDate() - 1);
              let yesterDate = dd.toLocaleDateString();
              let dateArr = _this.nowDate(yesterDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              let now = new Date();
              const year = now.getFullYear();
              const month = now.getMonth();
              const day = now.getDate();
              const week = now.getDay();

              let start = new Date(year, month, day - week + 1, 0, 0, 0);
              let end = new Date(year, month, day - week + 7, 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              let dateS = _this.getWeek(-1, 0).split("-");
              let dateE = _this.getWeek(-1, 1).split("-");

              let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0);
              let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              let str = _this.getCurrentDate();

              let arr = _this.getfirstDateAndlastDate(str);

              let arrS = arr[0].split("-");
              let arrE = arr[1].split("-");

              let start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              let end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              let str = _this.fromLastMonth();

              let arr = _this.getfirstDateAndlastDate(str);

              let arrS = arr[0].split("-");
              let arrE = arr[1].split("-");

              let start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              let end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.wxworkchatinspection {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.wxworkchatinspection >>> .el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 15px;
  text-align: right;
}

.middle-table {
  z-index: 1;
}

.keyword_list {
  margin-top: 0.28rem;
}

.hide-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.m-tabs-content {
  padding: 0px 0.2rem 0px 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/wx_work_chat_inspection/WxWorkChatInspection.vue